import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import Properties from "../components/Properties";
import { siteData } from "../mock";

export default function PropertiesPage() {
  const { primaryPhone, primaryPhoneRaw, whatsapp } = siteData.brand;
  return (
    <>
      <section className="py-20 md:py-28 bg-jk-cream border-b border-[#e7e2d7]">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <div className="text-[11px] tracking-[0.32em] text-[#b88b4a] mb-5">PROPERTIES</div>
          <h1 className="font-serif text-neutral-900 text-[44px] md:text-[76px] leading-[1.03] tracking-tight max-w-5xl">
            Tricity&apos;s most wanted <span className="italic">addresses.</span>
          </h1>
          <p className="mt-7 text-neutral-700 text-[16px] md:text-[18px] leading-[1.85] max-w-3xl">
            Every listing below is physically inspected and legally vetted. Contact us for pricing, site visits and full documentation — no portal-style runaround.
          </p>
        </div>
      </section>

      <Properties />

      <section className="py-16 md:py-20 bg-jk-navy text-white">
        <div className="max-w-5xl mx-auto px-5 md:px-10 text-center">
          <h2 className="font-serif text-[32px] md:text-[46px] leading-[1.1] tracking-tight">
            Can&apos;t find what you&apos;re looking for? <span className="italic text-[#c6a071]">We&apos;ll find it for you.</span>
          </h2>
          <p className="mt-5 text-white/75 text-[15px] md:text-[16.5px] max-w-2xl mx-auto">
            Share your brief — budget, location, purpose — and our team will shortlist 3 verified options within 24 hours.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href={`tel:${primaryPhoneRaw}`} className="btn-gold inline-flex items-center gap-2 px-7 py-3.5 text-[13px] tracking-wide font-medium">
              <Phone className="w-4 h-4" /> Call {primaryPhone}
            </a>
            <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer" className="btn-whatsapp inline-flex items-center gap-2 px-7 py-3.5 text-[13px] tracking-wide">
              <MessageCircle className="w-4 h-4" /> WhatsApp Us
            </a>
            <Link to="/contact" className="text-[#c6a071] hover:text-white inline-flex items-center gap-2 px-3 py-3.5 text-[13px] tracking-wide">
              Send enquiry <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
